import {
	createContext,
	Dispatch,
	SetStateAction,
	useState,
	useContext
} from "react";

export type Filters = {
	nameSearch: string;
	nameParts: string[];
	faceToFace: boolean;
	telehealth: boolean;
	localTelehealth: boolean;
	appointments: boolean;
	active: boolean;
	new: boolean;
};

const initialFilters: Filters = {
	nameSearch: "",
	nameParts: [],
	faceToFace: false,
	telehealth: false,
	localTelehealth: false,
	appointments: false,
	active: true,
	new: false
};

type DoctorsFiltersContextType = {
	filters: Filters;
	setFilters: Dispatch<SetStateAction<Filters>>;
};

type DoctorsFiltersContextTypeProviderProps = {
	children: React.ReactNode;
};

const DoctorsFiltersContext = createContext<
	DoctorsFiltersContextType | undefined
>(undefined);

export const DoctorsFiltersProvider = ({
	children
}: DoctorsFiltersContextTypeProviderProps) => {
	const [filters, setFilters] = useState<Filters>(initialFilters);

	return (
		<DoctorsFiltersContext.Provider
			value={{
				filters,
				setFilters
			}}
		>
			{children}
		</DoctorsFiltersContext.Provider>
	);
};

export const useDoctorsFiltersContext = () => {
	const context = useContext(DoctorsFiltersContext);
	if (context === undefined) {
		throw new Error(
			"useDoctorsFiltersContext must be used within a DoctorsFiltersProvider"
		);
	}
	return context;
};
